import { useNavigate } from "react-router-dom";

import LandingPageHeader from "../../components/Header/LandingPageHeader";
import PagesFooter from "components/Footer/PagesFooter";

import { Button, Container, Row, Col } from "reactstrap";

import "../../assets/scss/paper-dashboard/custom-pages/pages/_wcagInfo.scss"

const WcagInfo = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div id={"skipLinks"}>
        <a href={"#a11y-wstep"}>Przejdź do treści</a>
      </div>
      <LandingPageHeader />
      <div>
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" md="12">
              <ul className="breadcrumb-links">
                <li>
                  <a href="/">Strona główna </a>
                </li>
                <li>Dostępność cyfrowa</li>
              </ul>
            </Col>
          </Row>
        </Container>
        <div className="landing-section">
          <Container>
            <div className="wcag-box">
              <p id="a11y-wstep">
                <strong>
                  <span id="a11y-podmiot">Agencja Oceny Technologii Medycznych i Taryfikacji (AOTMiT)</span>
                </strong>{" "}
                zobowiązuje się zapewnić dostępność swojej strony internetowej zgodnie z przepisami ustawy z dnia 4
                kwietnia 2019 r. o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych.
                Oświadczenie w sprawie dostępności ma zastosowanie do strony internetowej{" "}
                <strong>
                  <a href="https://appsrk.aotm.gov.pl/" id="a11y-url">
                    https://appsrk.aotm.gov.pl/
                  </a>
                </strong>
                .
              </p>
              <ul>
                <li>
                  Data publikacji strony internetowej:{" "}
                  <time datetime="2024-06-29" id="a11y-data-publikacja">
                    29.06.2024
                  </time>
                </li>
                <li>
                  Data ostatniej istotnej aktualizacji:{" "}
                  <time datetime="2024-12-18" id="a11y-data-aktualizacja">
                    18.12.2024
                  </time>
                </li>
              </ul>
              <h2>Status pod względem zgodności z ustawą</h2>
              <p>
                Strona internetowa jest <b>częściowo zgodna</b> z ustawą o dostępności cyfrowej stron internetowych i
                aplikacji mobilnych podmiotów publicznych z powodu niezgodności lub wyłączeń wymienionych poniżej:
              </p>
              <ul>
                <li>
                  Nie wszystkie pliki są w pełni dostępne cyfrowo – mogą brakować w nich nagłówków lub opisów
                  alternatywnych.
                </li>
                <li>Nie wszystkie filmy zamieszczone na stronie posiadają napisy dla osób głuchych.</li>
              </ul>
              <h3>Przygotowanie deklaracji w sprawie dostępności</h3>
              <ul>
                <li>
                  Deklarację sporządzono dnia:{" "}
                  <time datetime="2024-07-04" id="a11y-data-sporzadzenie">
                    04.07.2024
                  </time>
                </li>
                <li>
                  Deklaracja została ostatnio poddana przeglądowi i aktualizacji dnia:{" "}
                  <time datetime="2024-12-18" id="a11y-data-deklaracja-przeglad">
                    18.12.2024
                  </time>
                </li>
              </ul>
              <p>Deklarację sporządzono na podstawie samooceny.</p>
              <h2 id="a11y-kontakt">Informacje zwrotne i dane kontaktowe</h2>
              <ul>
                <li>
                  Za rozpatrywanie uwag i wniosków odpowiada: <span id="a11y-osoba">AOTMiT</span>.
                </li>
                <li>
                  E-mail:{" "}
                  <span id="a11y-email">
                    <a href="mailto:webmaster@aotm.gov.pl">webmaster@aotm.gov.pl</a>
                  </span>
                </li>
                <li>
                  Telefon: <span id="a11y-telefon">+48 22 101 46 00</span>
                </li>
              </ul>
              <p id="a11y-procedura">Każdy ma prawo:</p>
              <ul>
                <li>zgłosić uwagi dotyczące dostępności cyfrowej strony lub jej elementu,</li>
                <li>zgłosić żądanie zapewnienia dostępności cyfrowej strony lub jej elementu,</li>
                <li>wnioskować o udostępnienie niedostępnej informacji w innej alternatywnej formie.</li>
              </ul>
              <p>Żądanie musi zawierać:</p>
              <ul>
                <li>dane kontaktowe osoby zgłaszającej,</li>
                <li>wskazanie strony lub elementu strony, której dotyczy żądanie,</li>
                <li>
                  wskazanie dogodnej formy udostępnienia informacji, jeśli żądanie dotyczy udostępnienia w formie
                  alternatywnej informacji niedostępnej.
                </li>
              </ul>
              <p>
                Rozpatrzenie zgłoszenia powinno nastąpić niezwłocznie, najpóźniej w ciągu 7 dni. Jeśli w tym terminie
                zapewnienie dostępności albo zapewnienie dostępu w alternatywnej formie nie jest możliwe, powinno
                nastąpić najdalej w ciągu 2 miesięcy od daty zgłoszenia.
              </p>
              <h3>Skargi i odwołania</h3>
              <p>
                Na niedotrzymanie tych terminów oraz na odmowę realizacji żądania można złożyć skargę do organu
                nadzorującego pocztą lub drogą elektroniczną na adres:
              </p>
              <ul>
                <li>
                  Organ nadzorujący:{" "}
                  <a
                    href="https://www.rpo.gov.pl/content/jak-zglosic-sie-do-rzecznika-praw-obywatelskich"
                    target="_blank"
                    rel="noopener"
                  >
                    Rzecznik Praw Obywatelskich
                  </a>
                </li>
                <li>Adres: Biuro Rzecznika Praw Obywatelskich, al. Solidarności 77, 00-090 Warszawa</li>
                <li>
                  E-mail: <a href="mailto:biurorzecznika@brpo.gov.pl">biurorzecznika@brpo.gov.pl</a>
                </li>
                <li>Telefon: +48 22 55 17 700</li>
              </ul>
              <h2 id="a11y-architektura">Dostępność architektoniczna</h2>
              <ul>
                <li>
                  Do budynku prowadzą 2 wejścia od ulicy Przeskok oznaczone literami A i B. Oba wejścia są na poziomie
                  gruntu. Nie ma przeszkód, by wjechać na wózku. W wejściu A znajdują się drzwi obrotowe, oraz szerokie
                  drzwi otwierane automatycznie przez pracownika Recepcji. W wejściu B znajdują się drzwi automatyczne.
                </li>
                <li>
                  Recepcja znajduje się na wprost od wejścia A oraz B. Dalsze przejście zabezpieczone jest bramkami,
                  przez które może przejechać osoba na wózku.
                </li>
                <li>
                  Toalety dla osób z niepełnosprawnościami znajdują się na piętrze 6 oraz 7 oraz przy recepcji B na
                  parterze.
                </li>
                <li>
                  Miejsca parkingowe dla osób z niepełnosprawnościami są przy ul. Zgody i ul. Brokla są to miejsca
                  parkingowe miejskie, położone najbliżej wejścia do budynku.
                </li>
                <li>Do budynku i wszystkich jego pomieszczeń można wejść z psem asystującym i psem przewodnikiem.</li>
                <li>W budynku nie ma pętli indukcyjnych.</li>
                <li>
                  W recepcji oraz w żadnym innym miejscu nie można skorzystać z tłumacza polskiego języka migowego.
                </li>
              </ul>
            </div>
          <div className="text-right">
            <Button
              className="btn-round"
              outline
              color="aotmit"
              onClick={() => {
                goBack();
                window.focus();
                window.scrollTo(0, 0);
              }}
            >
              Powrót
            </Button>
          </div>
          </Container>
        </div>
      </div>
      <PagesFooter />
    </>
  );
};

export default WcagInfo;
